(function () {
  'use strict';

  var MAX_RETRIES = 3;

  function buildFallbackOptionValues(responseHtml, changedOptionPosition, changedValueId, skipValueIds) {
    var variantSelects = responseHtml.querySelector('variant-selects');
    if (!variantSelects) return null;

    var optionGroups = variantSelects.querySelectorAll('[data-option-position]');
    var fallbackIds = [];

    optionGroups.forEach(function (group) {
      var position = parseInt(group.dataset.optionPosition, 10);

      if (position === changedOptionPosition) {
        fallbackIds.push(changedValueId);
        // console.log('[variant-fallback]   option ' + position + ': keeping changed value ' + changedValueId);
        return;
      }

      var allInputs = Array.from(group.querySelectorAll('[data-option-value-id]'));
      var checkedInput = group.querySelector('input:checked') || group.querySelector('[data-popout-input]');
      var checkedAvailable = checkedInput && checkedInput.dataset.available === 'true';
      var checkedSkipped = skipValueIds && checkedInput && skipValueIds.indexOf(checkedInput.dataset.optionValueId) !== -1;

      if (checkedInput && checkedAvailable && !checkedSkipped) {
        fallbackIds.push(checkedInput.dataset.optionValueId);
        // console.log('[variant-fallback]   option ' + position + ': keeping selected value ' + checkedInput.dataset.optionValueId + ' (available)');
        return;
      }

      var firstAvailable = allInputs.find(function (input) {
        if (skipValueIds && skipValueIds.indexOf(input.dataset.optionValueId) !== -1) return false;
        return input.dataset.available === 'true';
      });
      if (firstAvailable) {
        fallbackIds.push(firstAvailable.dataset.optionValueId);
        // console.log('[variant-fallback]   option ' + position + ': substituting with first available ' + firstAvailable.dataset.optionValueId + ' (value: ' + firstAvailable.value + ')');
      } else {
        var anyAvailable = allInputs.find(function (input) { return input.dataset.available === 'true'; });
        if (anyAvailable) {
          fallbackIds.push(anyAvailable.dataset.optionValueId);
          // console.log('[variant-fallback]   option ' + position + ': all non-skipped exhausted, using ' + anyAvailable.dataset.optionValueId);
        } else if (checkedInput) {
          fallbackIds.push(checkedInput.dataset.optionValueId);
          // console.log('[variant-fallback]   option ' + position + ': no available values, keeping selected ' + checkedInput.dataset.optionValueId);
        }
      }
    });

    return fallbackIds.length > 0 ? fallbackIds : null;
  }

  // rs-hover-disclosure element -- a WCAG compliant version of the theme.dev.js hover-disclosure
  if (!customElements.get('rs-hover-disclosure')) {
    customElements.define('rs-hover-disclosure', class RSHoverDisclosure extends HTMLElement {
      constructor() {
        super();
        this.selectors$i = {
          wrapper: '[data-header-wrapper]',
          stagger: '[data-stagger]',
          staggerPair: '[data-stagger-first]',
          staggerAfter: '[data-stagger-second]',
          focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]) a',
        };
        this.classes$e = {
          isVisible: 'is-visible',
          meganavVisible: 'meganav--visible',
          meganavIsTransitioning: 'meganav--is-transitioning',
        };
        this.trigger = this.querySelector('[aria-controls]');
        this.disclosure = document.getElementById(this.trigger?.getAttribute('aria-controls'));

        this.wrapper = this.closest(this.selectors$i.wrapper);
        this.grandparent = this.classList.contains('grandparent');
        this.transitionTimeout = 0;

      }
      connectedCallback() {
        this.trigger.setAttribute('aria-haspopup', true);
        this.trigger.setAttribute('aria-expanded', false);

        this.addEventListener('mouseenter', (e) => this.showDisclosure(e));
        this.addEventListener('mouseleave', () => this.hideDisclosure());
        this.addEventListener('focusin', (e) => { if (!this.isClosing) this.showDisclosure(e)});
        this.addEventListener('focusout', (e) => {
          // Only close if focus/mouse has truly left the custom element
          if (!e || !this.disclosure.contains(e.relatedTarget)) {
            this.hideDisclosure();
          }
        });
        this.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            this.isClosing = true; // 1. Set the flag
            this.hideDisclosure();    // 2. Close the menu
            this.trigger.focus();  // 3. Focus trigger (triggers focusin)
    
            // 4. Reset flag after the focus event finishes bubbling
            setTimeout(() => {
              this.isClosing = false;
            }, 0);
          }
        });
        this.handleTablets();
        this.staggerChildAnimations();
      }
      showDisclosure(e) {
        if (e && e.type && e.type === 'mouseenter') {
          this.wrapper.classList.add(this.classes$e.meganavIsTransitioning);
        }
        if (this.grandparent) {
          this.wrapper.classList.add(this.classes$e.meganavVisible);
        } else {
          this.wrapper.classList.remove(this.classes$e.meganavVisible);
        }
        this.trigger.setAttribute('aria-expanded', true);
        this.classList.add(this.classes$e.isVisible);
        this.disclosure.classList.add(this.classes$e.isVisible);

        if (this.transitionTimeout) {
          clearTimeout(this.transitionTimeout);
        }

        this.transitionTimeout = setTimeout(() => {
          this.wrapper.classList.remove(this.classes$e.meganavIsTransitioning);
        }, 200);
      }
      hideDisclosure() {
        this.classList.remove(this.classes$e.isVisible);
        this.disclosure.classList.remove(this.classes$e.isVisible);
        this.trigger.setAttribute('aria-expanded', false);
        this.wrapper.classList.remove(this.classes$e.meganavVisible, this.classes$e.meganavIsTransitioning);
      }
      staggerChildAnimations() {
        const simple = this.querySelectorAll(this.selectors$i.stagger);
        let step = 50;
        simple.forEach((el, index) => {
          el.style.transitionDelay = `${index * step + 10}ms`;
          step *= 0.95;
        });
        const pairs = this.querySelectorAll(this.selectors$i.staggerPair);
        pairs.forEach((child, i) => {
          const d1 = i * 100;
          child.style.transitionDelay = `${d1}ms`;
          child.parentElement.querySelectorAll(this.selectors$i.staggerAfter).forEach((grandchild, i2) => {
            const di1 = i2 + 1;
            const d2 = di1 * 20;
            grandchild.style.transitionDelay = `${d1 + d2}ms`;
          });
        });
      }
      handleTablets() {
        // first click opens the popup, second click opens the link
        this.addEventListener(
          'touchstart',
          function (e) {
            const isOpen = this.trigger.getAttribute('aria-expanded') === 'true';
            if (!isOpen) {
              e.preventDefault();
              this.showDisclosure(e);
            }
          }.bind(this),
          {passive: true}
        );
      }      
    });
  }

  /**
   * Variant Fallback
   *
   * When selected options don't form a valid variant, find the first available
   * variant that matches the changed option value instead of showing "unavailable".
   *
   * Uses the Section Rendering API + top-down availability from the response HTML.
   * Compatible with high-variant products (no /products/{handle}.js fetch).
   *
   * Requires:
   *   - data-variant-options-match on <variant-selects>
   *   - data-available on option value inputs
   *   - Loaded after product-info.js
   */
  customElements.whenDefined('product-info').then(function () {
    var ProductInfo = customElements.get('product-info');
    // console.log('[variant-fallback] product-info defined, ProductInfo:', !!ProductInfo);
    if (!ProductInfo) return;

    function idsMatch(a, b) {
      if (!a || !b || a.length !== b.length) return false;
      for (var i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) return false;
      }
      return true;
    }

    function handleResponseWithFallback(productInfoEl, url, html, changedOptionPosition, changedValueId, targetId, retryCount, previousIds) {
      var variantSelectsEl = html.querySelector('variant-selects');
      var matchAttr = variantSelectsEl ? variantSelectsEl.dataset.variantOptionsMatch : undefined;
      var optionsMatch = matchAttr === 'true';

      // console.log('[variant-fallback] response (retry ' + retryCount + '):', { variantOptionsMatch: matchAttr, optionsMatch: optionsMatch });

      if (optionsMatch) {
        // console.log('[variant-fallback] options match — normal update');
        productInfoEl.handleUpdateProductInfo(url)(html);
        return;
      }

      if (retryCount >= MAX_RETRIES) {
        // console.log('[variant-fallback] max retries reached, normal update');
        productInfoEl.handleUpdateProductInfo(url)(html);
        return;
      }

      // console.log('[variant-fallback] NO match (retry ' + retryCount + ') — building fallback from response availability');

      var fallbackIds = buildFallbackOptionValues(html, changedOptionPosition, changedValueId);
      // console.log('[variant-fallback] fallback option_values:', fallbackIds);

      if (!fallbackIds) {
        // console.log('[variant-fallback] could not build fallback, normal update');
        productInfoEl.handleUpdateProductInfo(url)(html);
        return;
      }

      if (idsMatch(fallbackIds, previousIds)) {
        // console.log('[variant-fallback] fallback IDs unchanged — trying aggressive substitution');
        var aggressiveIds = buildFallbackOptionValues(html, changedOptionPosition, changedValueId, previousIds);
        // console.log('[variant-fallback] aggressive fallback option_values:', aggressiveIds);

        if (!aggressiveIds || idsMatch(aggressiveIds, previousIds)) {
          // console.log('[variant-fallback] aggressive fallback also unchanged, normal update');
          productInfoEl.handleUpdateProductInfo(url)(html);
          return;
        }
        fallbackIds = aggressiveIds;
      }

      var fallbackUrl = productInfoEl.buildRequestUrlWithParams(url, fallbackIds, false);
      // console.log('[variant-fallback] retrying (' + (retryCount + 1) + '/' + MAX_RETRIES + ') with:', fallbackUrl);

      productInfoEl.renderProductInfo({
        requestUrl: fallbackUrl,
        targetId: targetId,
        callback: function (fallbackHtml) {
          handleResponseWithFallback(productInfoEl, url, fallbackHtml, changedOptionPosition, changedValueId, targetId, retryCount + 1, fallbackIds);
        },
      });
    }

    ProductInfo.prototype.handleOptionValueChange = function (eventData) {
      var event = eventData.data.event;
      var target = eventData.data.target;
      var selectedOptionValues = eventData.data.selectedOptionValues;

      // console.log('[variant-fallback] handleOptionValueChange fired', {
      //   containsTarget: this.contains(event.target),
      //   targetTag: target.tagName,
      //   optionValueId: target.dataset.optionValueId,
      //   optionValue: target.value,
      //   optionPosition: target.closest('[data-option-position]') ? target.closest('[data-option-position]').dataset.optionPosition : null,
      //   selectedOptionValues: selectedOptionValues,
      // });

      if (!this.contains(event.target)) return;
      this.resetProductFormState();

      var url = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
      this.pendingRequestUrl = url;
      var isSwap = this.dataset.url !== url;
      var fullPageSwap = this.dataset.updateUrl === 'true' && isSwap;

      if (isSwap) {
        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(url, selectedOptionValues, fullPageSwap),
          targetId: target.id,
          callback: this.handleSwapProduct(url, fullPageSwap),
        });
        return;
      }

      var positionEl = target.closest('[data-option-position]');
      var changedOptionPosition = positionEl ? parseInt(positionEl.dataset.optionPosition, 10) : null;
      var changedValueId = target.dataset.optionValueId;
      var requestUrl = this.buildRequestUrlWithParams(url, selectedOptionValues, false);
      var self = this;

      // console.log('[variant-fallback] fetching with all options:', requestUrl);

      this.renderProductInfo({
        requestUrl: requestUrl,
        targetId: target.id,
        callback: function (html) {
          if (!changedOptionPosition || !changedValueId) {
            self.handleUpdateProductInfo(url)(html);
            return;
          }
          handleResponseWithFallback(self, url, html, changedOptionPosition, changedValueId, target.id, 0, selectedOptionValues);
        },
      });
    };

    var elements = document.querySelectorAll('product-info');
    // console.log('[variant-fallback] re-subscribing', elements.length, 'product-info elements');
    elements.forEach(function (el) {
      if (typeof el.onVariantChangeUnsubscriber === 'function') {
        el.onVariantChangeUnsubscriber();
        el.onVariantChangeUnsubscriber = window.subscribe(
          window.theme.PUB_SUB_EVENTS.optionValueSelectionChange,
          el.handleOptionValueChange.bind(el)
        );
        // console.log('[variant-fallback] re-subscribed element:', el.id);
      } else {
        // console.log('[variant-fallback] element has no unsubscriber:', el.id);
      }
    });

    /**
     * Wrap handleUpdateProductInfo to dispatch a 'variant:update' event
     * after the Section Rendering API swaps the DOM.  Any element inside
     * <product-info> (including web components like <special-order-block>)
     * can listen for this event to react to variant changes.
     */
    const _origHandleUpdate = ProductInfo.prototype.handleUpdateProductInfo;
    ProductInfo.prototype.handleUpdateProductInfo = function (url) {
      const origCallback = _origHandleUpdate.call(this, url);
      return (html) => {
        origCallback(html);
        this.dispatchEvent(new CustomEvent('variant:update', { bubbles: true }));
      };
    };
  });

  /**
   * <special-order-block> – web component
   *
   * Shown when the selected variant has inventory_policy === 'continue'.
   * The Liquid template sets the initial hidden class + data-inventory-policy
   * on the element.  On variant change the Section Rendering API replaces
   * the DOM so connectedCallback fires with fresh Liquid state.  The
   * 'variant:update' listener is a safety net for partial DOM updates.
   */
  if (!customElements.get('special-order-block')) {
    customElements.define('special-order-block', class SpecialOrderBlock extends HTMLElement {
      connectedCallback() {
        this.syncVisibility();
        this.productInfo = this.closest('product-info');
        if (this.productInfo) {
          this._onVariantUpdate = this.syncVisibility.bind(this);
          this.productInfo.addEventListener('variant:update', this._onVariantUpdate);
        }
      }

      disconnectedCallback() {
        if (this.productInfo && this._onVariantUpdate) {
          this.productInfo.removeEventListener('variant:update', this._onVariantUpdate);
        }
      }

      syncVisibility() {
        const policy = this.dataset.inventoryPolicy;
        const wrapper = this.closest('.section-wrapper');
        if (policy === 'continue') {
          this.classList.remove('rs-hidden');
          wrapper?.classList.remove('rs-hidden');
        } else {
          this.classList.add('rs-hidden');
          wrapper?.classList.add('rs-hidden');
        }
      }
    });
  }
})();
